<p-dialog 
    [(visible)]="registroDialog"
    (onHide)="cancelarRegistro(null)"
    [breakpoints]="{'575px': '90vw' }"
    [style]="{width: '50%'}"
    header="Responder notificação" 
    [modal]="true"
    class="p-fluid"
    contentStyleClass="rounded-b border-t border-surface-200 dark:border-surface-700 p-0"
>
    <div class="p-0 m-0">
        <div class="bg-surface-0 dark:bg-surface-950 grid grid-cols-12 gap-4 p-6 rounded">
            <div class="col-span-12 md:col-span-6">
                <label for="de" class="block text-surface-900 dark:text-surface-0 font-semibold mb-2">De</label>
                <input id="de" type="text" pInputText class="w-full text-surface-900 dark:text-surface-0 font-semibold"
                    style="height: 3.5rem" [ngModel]="registro.usuarioRemetente?.email" [readonly]="true" />
            </div>

            <div class="col-span-12 md:col-span-6">
                <label for="subject"
                    class="block text-surface-900 dark:text-surface-0 font-semibold mb-2">Título</label>
                <input id="subject" type="text" pInputText placeholder="Título"
                    class="w-full text-surface-900 dark:text-surface-0 font-semibold" style="height: 3.5rem"
                    [(ngModel)]="registro.titulo" [readonly]="true" />
            </div>

            <div class="col-span-12">
                <label for="assunto"
                    class="block text-surface-900 dark:text-surface-0 font-semibold mb-2">Assunto</label>
                <input id="assunto" type="text" pInputText placeholder="Assunto"
                    class="w-full text-surface-900 dark:text-surface-0 font-semibold" style="height: 3.5rem"
                    [(ngModel)]="registro.assunto" [readonly]="true" />
            </div>

            <div class="col-span-12">
                <p-fieldset legend="Mensagem Recebida" [toggleable]="true" [collapsed]="true" class="mb-4 w-full">
                    <div class="p-editor-container w-full">
                        <div class="prose max-w-none break-words whitespace-pre-wrap overflow-auto w-full"
                            style="max-height: 300px; word-break: break-word;">
                            <div class="ql-editor" [innerHTML]="registro.notificacao"></div>
                        </div>
                    </div>
                </p-fieldset>
                <p-editor [style]="{ height: '300px' }" styleClass="mt-2" [(ngModel)]="registro.respostaNotificacao">
                    <p-header>
                        <span class="ql-formats">
                            <select class="ql-font"></select>
                            <select class="ql-size"></select>
                            <button class="ql-bold" aria-label="Negrito"></button>
                            <button class="ql-italic" aria-label="Itálico"></button>
                            <button class="ql-underline" aria-label="Sublinhado"></button>
                            <button class="ql-strike" aria-label="Tachado"></button>
                            <select class="ql-color"></select>
                            <select class="ql-background"></select>
                            <button class="ql-list" value="ordered" aria-label="Lista Ordenada"></button>
                            <button class="ql-list" value="bullet" aria-label="Lista Não Ordenada"></button>
                            <button class="ql-indent" value="-1" aria-label="Diminuir Identação"></button>
                            <button class="ql-indent" value="+1" aria-label="Aumentar Identação"></button>
                            <select class="ql-align"></select>
                            <button class="ql-link" aria-label="Inserir Link"></button>
                            <button class="ql-code-block" aria-label="Bloco de Código"></button>
                            <button class="ql-clean" aria-label="Limpar Formatação"></button>
                        </span>
                    </p-header>
                </p-editor>

                <div class="col-span-full lg:col-span-12 mt-6">
                    <div class="card">
                        <div class="font-semibold text-xl mb-4">Anexar Documentos</div>
                        <p-fileupload #fileUpload name="documentos[]" [multiple]="true" accept="image/*,application/pdf"
                            [maxFileSize]="5000000" mode="advanced" chooseLabel="Selecionar Arquivos"
                            uploadLabel="Enviar" cancelLabel="Cancelar" (onSelect)="onFileSelect($event)"
                            (onRemove)="onRemove($event)" (onClear)="onClear()">
                            <ng-template pTemplate="empty">
                                <div class="text-center text-gray-500">
                                    Arraste e solte arquivos aqui para anexar.
                                </div>
                            </ng-template>

                            <ng-template pTemplate="content">
                                <div class="space-y-4">
                                    <div class="border-t border-gray-200 pt-3">
                                        <small class="text-gray-600 font-medium">Lista de arquivos dessa
                                            notificação</small>
                                    </div>

                                    <div *ngIf="registroDocumentos.length" class="w-full">
                                        <div class="space-y-2">
                                            <ng-container *ngFor="let file of registroDocumentos; let i = index">
                                                <div *ngIf="isImage(file.documento)"
                                                    class="flex items-center justify-between p-2 hover:bg-gray-50 rounded">
                                                    <div class="flex items-center space-x-3 cursor-pointer"
                                                        (click)="visualizarDocumento(file)">
                                                        <img [src]="file.arquivo" [alt]="file.documento"
                                                            class="w-10 h-10 object-cover rounded-md shadow-sm" />
                                                        <span class="text-sm text-gray-700">
                                                            {{ file.documento }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </p-fileupload>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" label="Cancelar" class=" p-button-danger" (click)="cancelarRegistro(null)"
            [disabled]="loading"></button>
        <button pButton pRipple type="button" [label]="loading ? 'Enviando...' : 'Responder'" (click)="salvarRegistro()" 
            [disabled]="loading" icon="pi pi-check" class="p-button-success" [loading]="loading"></button>
    </ng-template>
</p-dialog>